import React, { useEffect, useRef, useState } from 'react';
import './styles.scss';
import ResizeObserver from 'resize-observer-polyfill';
import PropTypes from 'prop-types';

function AnimateAutoHeight( { children, ...others } ) {
	const [ height, setHeight ] = useState( 50 );
	const innerRef = useRef();

	useEffect( () => {
		const updateHeight = ( e ) => {
			if ( e[ 0 ].target ) {
				setHeight( e[ 0 ].target.getBoundingClientRect().height );
			}
		};

		const ro = new ResizeObserver( updateHeight );

		if ( innerRef.current ) {
			ro.observe( innerRef.current );
		}

		return () => {
			ro.disconnect();
		};
	}, [ innerRef ] );

	return (
		<div
			{ ...others }
			className={ `dhsv-animate-auto-height ${
				others.className ? others.className : ''
			}` }
			style={ { height } }
		>
			<div ref={ innerRef }>{ children }</div>
		</div>
	);
}

AnimateAutoHeight.propTypes = {
	children: PropTypes.any,
};

AnimateAutoHeight.defaultProps = {
	children: null,
};

export default AnimateAutoHeight;
